import { createSvgComponent } from "../../icon/createSvgComponent";
import FileTextHeart from "@core/icon/assets/file-text-heart.svg";
export default createSvgComponent(FileTextHeart);